import React from "react";
import { Box, Button, Checkbox, Typography, useTheme } from "@mui/material";
import { InlineIcon } from "@iconify/react";

interface OcRoleFilterSubtypeItemProps {
  selected: boolean;
  onClick: () => void;
  label: string;
  isCheckboxes?: boolean;
  editable?: boolean;
}

export const OcRoleFilterSubtypeItem: React.FC<
  OcRoleFilterSubtypeItemProps
> = ({ selected, onClick, label, isCheckboxes, editable = true }) => {
  const theme = useTheme();

  const RENDERS = {
    nonEditable: (
      <Typography padding="4px 8px" variant="body1">
        {label}
      </Typography>
    ),
    checkboxes: (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "0px 31px",
          width: "fit-content",
          cursor: "pointer",
        }}
        onClick={onClick}
      >
        <Checkbox
          checked={selected}
          sx={{
            height: "42px",
          }}
        />
        <Typography>{label}</Typography>
      </Box>
    ),
    nonCheckboxes: (
      <Button
        variant="text"
        onClick={onClick}
        disabled={selected}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          height: "auto",
          color: theme.palette.darkBase.main,
          "&.MuiButton-textPrimary:hover": {
            color: theme.palette.darkBase.main,
            backgroundColor: "#0000000a",
          },
          padding: "4px 8px",
        }}
      >
        <Typography color="inherit" textTransform="none" textAlign="left">
          {label}
        </Typography>
        <InlineIcon
          icon="mdi:plus-thick"
          style={{
            minWidth: "12px",
            minHeight: "12px",
            width: "12px",
            height: "12px",
            padding: "0px 4px",
          }}
        />
      </Button>
    ),
  };
  if (!editable) return RENDERS.nonEditable;
  if (isCheckboxes) return RENDERS.checkboxes;
  else return RENDERS.nonCheckboxes;
};
